import styled, { css } from "styled-components";

import { stylesGlobalDefault } from "../../../../../global/globalStyle";

interface IEditorContainer {
  error?: boolean;
}

export const EditorContainer = styled.div<IEditorContainer>`
  border: 2px solid ${stylesGlobalDefault.inputsBorderFocusOff};

  ${(props) =>
    props.error &&
    css`
      border: 2px solid ${stylesGlobalDefault.inputsBorderFocusError};
    `}
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
`;
